import { Box, Heading, Text, Container, useColorMode } from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";

const ShotShowFooter = () => {
  const { colorMode } = useColorMode();

  return (
    <Box
      bg={getCurrentColor(colorMode, "whiteC.200", "blueC.500")}
      borderTop="1px solid"
      borderColor={getCurrentColor(colorMode, "grayC.500", "grayC.2000")}
      py={{ base: 12, md: 16 }}
    >
      <Container maxW="7xl">
        <Heading
          as="h3"
          fontSize={{ base: "xl", md: "2xl" }}
          fontWeight="700"
          color={getCurrentColor(colorMode, "blackC.100", "whiteC.200")}
          mb={4}
          lineHeight="tight"
        >
          SHOT Show is one week. BulletScout works year-round.
        </Heading>
        <Text
          fontSize="sm"
          color={getCurrentColor(colorMode, "grayC.300", "grayC.700")}
        >
          © BulletScout. Independent ammo price comparison.
        </Text>
      </Container>
    </Box>
  );
};

export default ShotShowFooter;